import sanitizeHtml from 'sanitize-html';

export const sanitizeHtmlContent = (html: string): string => {
  return sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img']),
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      '*': ['style', 'class'],
    },
  });
};

/**
 * Strips all HTML tags from a string, returning plain text only.
 * Use for user-provided content that should never contain HTML,
 * such as email message fields passed to notification templates.
 */
export const stripHtmlContent = (html: string): string => {
  return sanitizeHtml(html, {
    allowedTags: [],
    allowedAttributes: {},
  });
};
